/* eslint-disable */
/**
 * SocketProxy class which implements the functions of a WebSocket. But instead of actually
 * emitting data via the WebSocket it will post message to parent window.
 *
 * The reason for this is specfially for embeds and only having all analytics sent via a single socket.
 * As there can live many embeds on a single page.
 */
class SocketProxy {
  isReady = false;

  onmessage() {}

  onclose() {}

  send(data) {
    // Check for iframe here
    // For now will bubble event up
    window.parent.postMessage(`youvisit:trackAnalytics:${data}`, "*");
  }

  sendMessage(action, message) {
    this.send(
      JSON.stringify({
        action,
        data: message
      })
    );
  }

  close() {}
}

export default SocketProxy;
